import { ODMProvider } from "../ApiServiceProviders";

export const uploadImageInference = ({ fields, params, config }) => {
  return ODMProvider.clientUpload
    .post(`/inference/back/ai/image/inference/${params.alias}`, fields, config)
    .then((response) => response)
    .catch((error) => error.response);
};
